import axios from "axios";
import React, { Component, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../constant.js";

/** Plain object only — arrays/null must not go to Object.entries */
const asPlainObject = (val) => {
  if (!val || typeof val !== "object" || Array.isArray(val)) return {};
  return val;
};

const asArray = (val) => (Array.isArray(val) ? val.filter(Boolean) : []);

/** Support both { ...fields } and { data: { ...fields } } API shapes */
const normalizeProfile = (raw) => {
  if (!raw || typeof raw !== "object") return {};
  if (raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)) {
    const inner = raw.data;
    // Prefer inner if it looks like profile payload
    if (
      inner.mcx_intraday != null ||
      inner.nse_brokerage != null ||
      inner.mcx_brokerage_type != null ||
      inner.option_brokerage_type != null
    ) {
      return inner;
    }
  }
  return raw;
};

class ProfileErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Something went wrong" };
  }

  componentDidCatch(error) {
    console.error("Profile render error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, textAlign: "center" }}>
          <p>Profile load nahi ho paya.</p>
          <p style={{ fontSize: 12, opacity: 0.7 }}>{this.state.message}</p>
          <Link to="/seeting">Back to Settings</Link>
        </div>
      );
    }
    return this.props.children;
  }
}

const ProfileInner = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const profiledata = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const formdata = new FormData();
      formdata.append("Token", token);
      const result = await axios.post(
        baseUrl + `authController/getProfileData`,
        formdata,
      );
      setData(normalizeProfile(result?.data));
    } catch (err) {
      console.log(err);
      setError("Profile data fetch failed. Please try again.");
      setData({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    profiledata();
  }, []);

  const mcxIntraday = asArray(data?.mcx_intraday);
  const mcxHolding = asArray(data?.mcx_holding);
  const mcxBrokeragePerLot = asPlainObject(data?.mcx_brokerage_per_lot);
  const optionBrokeragePerLot = asPlainObject(data?.option_brokerage_per_lot);

  const formatMarginList = (list) =>
    list
      .map((item) => {
        if (!item || typeof item !== "object") return null;
        const title = item.title ?? item.name ?? "";
        const margin = item.margin ?? item.value ?? "";
        if (title === "" && margin === "") return null;
        return `${title}: ${margin}`;
      })
      .filter(Boolean)
      .join(", ");

  return (
    <section className="online_trade_view">
      <div className="text-center">
        <div className="onine_view_col">
          <div className="phone_frame">
            <div className="frame_screen">
              <div className="screen_body p-0">
                <div className="dashboard_main">
                  <div className="dashboard_header">
                    <div>
                      <Link to="/seeting">
                        <i className="fa fa-angle-left"></i>
                      </Link>
                    </div>
                    <div>
                      <h4>Profile</h4>
                    </div>
                    <div>
                      <div className="ui_dropdown">
                        <button
                          className="btn btn-secondary dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fa fa-ellipsis-v"></i>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="/profile">
                              My Profile
                            </Link>
                          </li>
                          <li>
                            <Link className="dropdown-item" to="/logout">
                              Logout
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="market_tab_col">
                    <div className="tab-content dashboard_col_tabs">
                      {loading || data == null ? (
                        <div style={{ padding: 20, textAlign: "center" }}>
                          Loading profile...
                        </div>
                      ) : error ? (
                        <div style={{ padding: 20, textAlign: "center" }}>
                          <p>{error}</p>
                          <button type="button" onClick={profiledata}>
                            Retry
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="trading_enable_Box">
                            <h3>
                              <span>NSE </span>
                              <span className="Profiletrading">
                                Trading Enabled
                              </span>
                            </h3>
                            <div className="trading_history_list">
                              <ul>
                                <li>
                                  <span>Brokerage</span>{" "}
                                  {data.nse_brokerage ?? "--"} per Crore
                                </li>
                                <li>
                                  <span>Margin Intraday</span> Turnover /{" "}
                                  {data.nse_intraday_margin ?? "--"}
                                </li>
                                <li>
                                  <span>Margin Holding</span> Turnover /{" "}
                                  {data.nse_holding_margin ?? "--"}
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="trading_enable_Box m-t10">
                            <h3>
                              <span>MCX</span>{" "}
                              <span className="Profiletrading">
                                Trading Enabled
                              </span>
                            </h3>

                            <div className="trading_history_list">
                              <ul>
                                {data.mcx_brokerage_type ? (
                                  data.mcx_brokerage_type === "Per Crore" ? (
                                    <li>
                                      <span>Brokerage</span>{" "}
                                      {data.mcx_brokerage ?? "--"} per Crore
                                    </li>
                                  ) : (
                                    <li>
                                      <h6 style={{ color: "#194f4f" }}>
                                        Brokerage Per Lot
                                      </h6>
                                      <p>
                                        {Object.entries(mcxBrokeragePerLot)
                                          .map(
                                            ([key, value]) =>
                                              `${key}: ${value}`,
                                          )
                                          .join(", ") || "--"}
                                      </p>
                                    </li>
                                  )
                                ) : null}

                                <li>
                                  <span>Margin Intraday</span>{" "}
                                  {formatMarginList(mcxIntraday) || "--"}
                                </li>

                                <li>
                                  <span>Margin Holding</span>{" "}
                                  {formatMarginList(mcxHolding) || "--"}
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div className="trading_enable_Box">
                            <h3>
                              <span>Option </span>
                              <span className="Profiletrading">
                                Trading Enabled
                              </span>
                            </h3>
                            <div className="trading_history_list">
                              <ul>
                                {data.option_brokerage_type ? (
                                  data.option_brokerage_type === "Per Crore" ? (
                                    <li>
                                      <span>Brokerage</span>{" "}
                                      {data.option_brokerage_per_crore ?? "--"}{" "}
                                      per Crore
                                    </li>
                                  ) : (
                                    <li>
                                      <span>Brokerage</span>
                                      {Object.entries(optionBrokeragePerLot)
                                        .length === 0
                                        ? " --"
                                        : Object.entries(
                                            optionBrokeragePerLot,
                                          ).map(([key, value]) => (
                                            <div key={key}>
                                              <h4>{key}</h4> : {String(value)}
                                            </div>
                                          ))}
                                      Per Lot
                                    </li>
                                  )
                                ) : null}
                                <li>
                                  <span>Margin Intraday</span> Turnover /{" "}
                                  {data.option_intraday_margin ?? "--"}
                                </li>
                                <li>
                                  <span>Margin Holding</span> Turnover /{" "}
                                  {data.option_holding_margin ?? "--"}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Profile = () => (
  <ProfileErrorBoundary>
    <ProfileInner />
  </ProfileErrorBoundary>
);

export default Profile;
